import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const TrendingTopics = () => {
  const [activeCategory, setActiveCategory] = useState('reviews');

  const categories = [
  { id: 'reviews', label: 'Latest Reviews', icon: 'Star' },
  { id: 'guides', label: 'Buying Guides', icon: 'BookOpen' },
  { id: 'deals', label: 'Hot Deals', icon: 'Tag' },
  { id: 'comparisons', label: 'Comparisons', icon: 'GitCompare' }];


  const trendingContent = {
    reviews: [
    {
      id: 1,
      title: 'Dyson V15 Detect Complete Review',
      excerpt: 'We put the latest Dyson through 30 days of rigorous testing. Here\'s what we found about its laser dust detection and powerful suction.',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e4d98958-1768061388011.png",
      alt: 'Modern cordless vacuum cleaner with digital display on hardwood floor',
      category: 'Cordless',
      readTime: '8 min read',
      rating: 4.8,
      trending: true,
      publishedAt: '2 days ago'
    },
    {
      id: 2,
      title: 'Shark Navigator vs Bissell CrossWave',
      excerpt: 'Head-to-head comparison of two popular mid-range vacuums. Which one offers better value for money?',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d4b4b0ce-1766875571363.png",
      alt: 'Blue upright vacuum cleaner with detachable canister on carpet',
      category: 'Upright',
      readTime: '6 min read',
      rating: 4.5,
      trending: false,
      publishedAt: '5 days ago'
    },
    {
      id: 3,
      title: 'Best Robot Vacuums for Pet Hair 2024',
      excerpt: 'Tested 12 robot vacuums to find the champions of pet hair removal. Surprising results inside.',
      image: "https://images.unsplash.com/photo-1687443093393-2406de382ced",
      alt: 'Round robot vacuum cleaner on hardwood floor near pet bed',
      category: 'Robot',
      readTime: '12 min read',
      rating: 4.7,
      trending: true,
      publishedAt: '1 week ago'
    }],

    guides: [
    {
      id: 4,
      title: 'Complete Vacuum Buying Guide 2024',
      excerpt: 'Everything you need to know before buying a vacuum cleaner. From suction power to filtration systems.',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13054d87b-1769336060202.png",
      alt: 'Various vacuum cleaner types displayed in modern showroom',
      category: 'Guide',
      readTime: '15 min read',
      views: '45K views',
      trending: true,
      publishedAt: '3 days ago'
    },
    {
      id: 5,
      title: 'Hardwood Floor Vacuum Selection',
      excerpt: 'Protect your investment with the right vacuum. Learn which features matter most for hardwood floors.',
      image: "https://images.unsplash.com/photo-1723810778252-4406ab0bd614",
      alt: 'Elegant hardwood floor in modern living room with area rug',
      category: 'Flooring',
      readTime: '10 min read',
      views: '32K views',
      trending: false,
      publishedAt: '1 week ago'
    }],

    deals: [
    {
      id: 6,
      title: 'Dyson V12 Detect Slim - 30% Off',
      excerpt: 'Limited time offer on this lightweight powerhouse. Perfect for apartments and quick cleanups.',
      image: "https://images.unsplash.com/photo-1683370297427-15491dc0696c",
      alt: 'Slim cordless vacuum cleaner standing against white wall',
      category: 'Deal',
      originalPrice: '$649',
      salePrice: '$454',
      savings: '$195',
      trending: true,
      expiresAt: '2 days left'
    },
    {
      id: 7,
      title: 'Shark Navigator Professional - 40% Off',
      excerpt: 'Best-selling upright vacuum at its lowest price ever. Includes free shipping and extended warranty.',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3d9d758-1766875572285.png",
      alt: 'Professional upright vacuum cleaner in home setting',
      category: 'Deal',
      originalPrice: '$299',
      salePrice: '$179',
      savings: '$120',
      trending: true,
      expiresAt: '5 days left'
    }],

    comparisons: [
    {
      id: 8,
      title: 'Cordless vs Corded: Which is Right for You?',
      excerpt: 'Comprehensive analysis of cordless and corded vacuums. Performance, convenience, and cost compared.',
      image: "https://images.unsplash.com/photo-1615804506861-496774403b57",
      alt: 'Side by side comparison of cordless and corded vacuum cleaners',
      category: 'Comparison',
      readTime: '7 min read',
      comparisons: 8,
      trending: false,
      publishedAt: '4 days ago'
    }]

  };

  const activeContent = trendingContent?.[activeCategory] || [];

  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Trending Now
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay updated with the latest vacuum reviews, buying guides, and exclusive deals from our expert team.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories?.map((category) =>
          <button
            key={category?.id}
            onClick={() => setActiveCategory(category?.id)}
            className={`flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all duration-200 ${
            activeCategory === category?.id ?
            'bg-primary text-white shadow-lg' :
            'bg-gray-100 text-gray-600 hover:bg-gray-200'}`
            }>

              <Icon name={category?.icon} size={18} />
              <span>{category?.label}</span>
            </button>
          )}
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {activeContent?.map((item) =>
          <article
            key={item?.id}
            className="bg-white rounded-xl shadow-subtle hover:shadow-floating transition-all duration-300 overflow-hidden group">

              <div className="relative">
                <div className="aspect-video overflow-hidden">
                  <Image
                  src={item?.image}
                  alt={item?.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />

                </div>
                
                {/* Badges */}
                <div className="absolute top-4 left-4 flex gap-2">
                  <span className="bg-primary text-white px-3 py-1 rounded-full text-xs font-semibold">
                    {item?.category}
                  </span>
                  {item?.trending &&
                <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
                      <Icon name="TrendingUp" size={12} />
                      Trending
                    </span>
                }
                </div>

                {/* Deal Pricing */}
                {activeCategory === 'deals' &&
              <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg p-2">
                    <div className="text-right">
                      <div className="text-lg font-bold text-green-600">{item?.salePrice}</div>
                      <div className="text-sm text-gray-500 line-through">{item?.originalPrice}</div>
                    </div>
                  </div>
              }
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors duration-200">
                  {item?.title}
                </h3>
                
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {item?.excerpt}
                </p>

                {/* Metadata */}
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <div className="flex items-center space-x-4">
                    {item?.readTime &&
                  <div className="flex items-center space-x-1">
                        <Icon name="Clock" size={14} />
                        <span>{item?.readTime}</span>
                      </div>
                  }
                    
                    {item?.rating &&
                  <div className="flex items-center space-x-1">
                        <Icon name="Star" size={14} className="text-yellow-500 fill-current" />
                        <span>{item?.rating}</span>
                      </div>
                  }
                    
                    {item?.views &&
                  <div className="flex items-center space-x-1">
                        <Icon name="Eye" size={14} />
                        <span>{item?.views}</span>
                      </div>
                  }
                    
                    {item?.savings &&
                  <div className="flex items-center space-x-1 text-green-600 font-semibold">
                        <Icon name="Tag" size={14} />
                        <span>Save {item?.savings}</span>
                      </div>
                  }
                  </div>
                  
                  <span>{item?.publishedAt || item?.expiresAt}</span>
                </div>

                {/* CTA Button */}
                <Button
                variant={activeCategory === 'deals' ? 'default' : 'outline'}
                size="sm"
                iconName="ArrowRight"
                iconPosition="right"
                fullWidth
                asChild>

                  <Link to={activeCategory === 'deals' ? '/deal-tracker' : '/product-review'}>
                    {activeCategory === 'deals' ? 'View Deal' : 'Read More'}
                  </Link>
                </Button>
              </div>
            </article>
          )}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <Button
            variant="outline"
            size="lg"
            iconName="Grid3X3"
            iconPosition="left"
            asChild>

            <Link to={`/${activeCategory === 'reviews' ? 'product-review' : activeCategory === 'guides' ? 'buying-guide' : activeCategory === 'deals' ? 'deal-tracker' : 'comparison-tool'}`}>
              View All {categories?.find((c) => c?.id === activeCategory)?.label}
            </Link>
          </Button>
        </div>
      </div>
    </section>);

};

export default TrendingTopics;